import ReverseChargeDeterminer from "@/module/Form/ReverseCharge/Strategy/ReverseChargeDeterminer";
import ForeignCustomerDeterminer from "@/module/Form/VatDeterminer/ForeignCustomerDeterminer";

export default class ForeignCustomerWithValidDicReverseChargeDeterminer
  implements ReverseChargeDeterminer
{
  private readonly foreignCustomerDeterminer: ForeignCustomerDeterminer;
  private readonly baseUrl: string;
  private readonly formPath: string;
  private vatIdCache: { [key: string]: Promise<boolean> } = {};

  constructor(
    foreignCustomerDeterminer: ForeignCustomerDeterminer,
    baseUrl: string,
    formPath: string,
  ) {
    this.foreignCustomerDeterminer = foreignCustomerDeterminer;
    this.baseUrl = baseUrl;
    this.formPath = formPath;
  }

  async determinate(
    country: string | null = null,
    ic: string | null = null,
    dic: string | null = null,
    icDph: string | null = null,
  ): Promise<boolean> {
    if (!this.foreignCustomerDeterminer.isForeignCustomer(country)) {
      return false;
    }

    let vatId = country === "SK" ? icDph : dic;

    if (vatId === null || vatId === "") {
      return false;
    }

    vatId = vatId.toUpperCase();

    if (this.vatIdCache.hasOwnProperty(vatId)) {
      return this.vatIdCache[vatId];
    }

    this.vatIdCache[vatId] = this.getResult(vatId);

    return this.vatIdCache[vatId];
  }

  private async getResult(vatId: string, retryCount = 0): Promise<boolean> {
    try {
      return fetch(
        this.baseUrl +
          "/check-vat-id?path=" +
          this.formPath +
          "&vatId=" +
          vatId,
        {
          credentials: "omit",
        },
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (json: { valid: boolean | number }) {
          return Boolean(json.valid);
        });
    } catch (e) {
      if (retryCount > 10) {
        return false;
      }

      return this.getResult(vatId, ++retryCount);
    }
  }
}
